import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { StyleSheetManager } from 'styled-components';
import { App } from './App';
import { GlobalStyles } from './styles/GlobalStyles';
import { ThemeModeProvider } from './providers/ThemeModeProvider';
import { AuthProvider } from './providers/AuthProvider';
import { initConsoleMessage } from './utils/consoleMessage';
import { initCoopenEvents } from './utils/coopenEvents';

initConsoleMessage();
initCoopenEvents();

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(
  <StrictMode>
    <BrowserRouter>
      <StyleSheetManager disableCSSOMInjection>
        <ThemeModeProvider>
          <GlobalStyles />
          <AuthProvider>
            <App />
          </AuthProvider>
        </ThemeModeProvider>
      </StyleSheetManager>
    </BrowserRouter>
  </StrictMode>
);
